<template>
  <div class="container-xl mt-4">
    <div class="row row-cards">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">出金錢包地址設定</h3>
          </div>
          <div class="card-body">
            <div
              :class="
                alertStatus === 'success'
                  ? 'alert alert-success'
                  : 'alert alert-danger'
              "
              v-show="alertStatus !== ''"
              role="alert"
            >
              {{ alertMsg }}
            </div>
            <form pb-autologin="true" autocomplete="off">
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label"
                  >Ethereum 地址</label
                >
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="0x7ffC57839B00206D1ad20c69A1981b489f772031"
                    v-model="ethereumWalletAddress"
                    :disabled="!checkPermission"
                  />
                </div>
              </div>
              <div class="form-group mb-3 row">
                <label class="form-label col-3 col-form-label">Tron 地址</label>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="TFysCB929XGezbnyumoFScyevjDggu3BPq"
                    v-model="tronWalletAddress"
                    :disabled="!checkPermission"
                  />
                </div>
              </div>
              <div class="row mb-3 align-items-center">
                <div class="col-6"></div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <router-link
                        to="customerWithdrawal"
                        class="btn btn-outline-secondary w-100"
                      >
                        返回
                      </router-link>
                    </div>
                    <div class="col-6">
                      <button
                        type="submit"
                        class="btn btn-outline-primary w-100"
                        @click.prevent="setWalletAddress"
                        :disabled="!checkPermission"
                      >
                        設定
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      alertMsg: "",
      alertStatus: "",
      token: "",
      key: "",
      tronWalletAddress: "",
      ethereumWalletAddress: "",
      checkPermission: false,
    };
  },
  methods: {
    async setWalletAddress() {
      if (this.setETHAddress === "") {
        this.alertStatus = "error";
        this.alertMsg = "請填寫資訊";
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/disperseWithdrawWallets`;
        const vm = this;
        let disperseWalletAddress = JSON.stringify({
          tron: vm.tronWalletAddress,
          ethereum: vm.ethereumWalletAddress,
        });

        try {
          const res = await this.$http.patch(
            api,
            { disperseWalletAddress: disperseWalletAddress },
            {
              headers: { Authorization: `Bearer ${this.token}` },
            }
          );
          if (!res.data.data) {
            throw "error";
          }
          this.alertStatus = "success";
          this.alertMsg = "設定成功";
        } catch (err) {
          if (err.response.status === 401) {
            this.$parent.$parent.isExpired = true;
            this.$parent.$parent.checkSessionExpired()
          }
          this.alertStatus = "error";
          this.alertMsg = "錯誤";
        }
      }
    },
    async getWallets() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/setting`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (!res.data.data.merchantSetting.disperseWalletAddress) {
          this.tronWalletAddress = "";
          this.ethereumWalletAddress = "";
        } else {
          const wallets = JSON.parse(
            res.data.data.merchantSetting.disperseWalletAddress
          );
          this.tronWalletAddress = wallets.tron;
          this.ethereumWalletAddress = wallets.ethereum;
        }
        this.checkPermission = true;
      } catch (err) {
        if (err.response.status === 401) {
          this.alertStatus = "error";
          this.alertMsg = "請等待驗證完成";
        } else {
          if (err.response.status === 401) {
            this.$parent.$parent.isExpired = true;
            this.$parent.$parent.checkSessionExpired()
          }
          this.alertStatus = "error";
          this.alertMsg = "無法取得地址";
        }
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getWallets();
  },
};
</script>
